import styles from "./index.module.scss";
import { Spacer } from "../Atoms/Vectors";
import { ReactNode } from "react-markdown/lib/react-markdown";

const MenuBar = ({
  color,
  children,
  type,
}: {
  color: any;
  children: ReactNode;
  type: any;
}) => {
  const style = {
    "--color": color?.hex,
  } as React.CSSProperties;
  switch (type) {
    case "concave":
      return (
        <div
          style={style as React.CSSProperties}
          className={styles.menuBarConcave}
        >
          <Spacer color={color} type={type} />
          {children}
        </div>
      );
      break;
    case "straight":
      return (
        <div
          style={style as React.CSSProperties}
          className={`${styles.menuBarStraight} fixed  w-full h-[70px] lg:h-[100px] z-[15000] flex items-center`}
        >
          {children}
        </div>
      );
      break;
    default:
      return <></>;
      break;
  }
};

export default MenuBar;
